import { Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import NotFoundImage from '../../assets/icons/404.svg';

const PageNotFound = () => {
    const navigate = useNavigate();
    const { t } = useTranslation('common');

    const isFirstAccess = window.history.length <= 2;

    return (
        <Box
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            height="100vh"
            textAlign="center"
            px={2}
        >
            <img
                src={NotFoundImage}
                alt="404 Not Found"
                style={{ maxWidth: 400, marginBottom: 24 }}
            />

            <Typography variant="h4" gutterBottom>
                {t('pageNotFound.title')}
            </Typography>
            <Typography variant="body1" mb={3}>
                {t('pageNotFound.description')}
            </Typography>

            {isFirstAccess ? (
                <Button variant="contained" color="primary" onClick={() => navigate('/')}>
                    {t('pageNotFound.goHomeButton')}
                </Button>
            ) : (
                <Button variant="contained" color="primary" onClick={() => navigate(-1)}>
                    {t('pageNotFound.backButton')}
                </Button>
            )}
        </Box>
    );
};

export default PageNotFound;
